import { getLocalizedString } from "owa-datetime-formatters-core";
import { format } from "owa-localize";

export default function formatDayAtTime(day: string, time: string): string {
    return format(getLocalizedString("weekdayAtTime"), day, time);
}
